var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5684a583834c6742b11b8b3df0b4d8d39a2e78e9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sv-hero-web@socialvenu"]={id:"5684a583834c6742b11b8b3df0b4d8d39a2e78e9"};
      